const DetailsCommunication = () => import("@/views/details/communication.vue");
const DetailsAddress = () => import("@/views/details/address.vue");

export default [
    { path: "/details/communication", name: "details_communication", component: DetailsCommunication, props: true, meta: {title: 'Communication'} },
    { path: "/details/address", name: "details_address", component: DetailsAddress, props: true, meta: {title: 'Addresses'} },
]
